import { Injectable, signal } from '@angular/core';

export type ThemeMode = 'dark' | 'system' | 'light';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly KEY = 'pc-theme';
  private readonly mq = window.matchMedia('(prefers-color-scheme: dark)');

  mode = signal<ThemeMode>('system');

  constructor() {
    const saved = localStorage.getItem(this.KEY) as ThemeMode | null;
    this._apply(saved ?? 'system');
    this.mq.addEventListener('change', () => {
      if (this.mode() === 'system') this._applyResolved();
    });
  }

  setMode(m: ThemeMode) {
    localStorage.setItem(this.KEY, m);
    this._apply(m);
  }

  private _apply(m: ThemeMode) {
    this.mode.set(m);
    this._applyResolved();
  }

  private _applyResolved() {
    const isDark = this.mode() === 'dark' || (this.mode() === 'system' && this.mq.matches);
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
  }
}
